<template>
  <div class="py-3 border-b-2 border-[#FFD13C] dark:border-gray-800 font-semibold">
    <div
      class="flex px-6 container md:max-w-2xl lg:max-w-4xl xl:max-w-5xl 2xl:max-w-7xl justify-between mx-auto items-baseline"
    >
      <ul class="flex items-baseline space-x-5 mx-auto sm:mx-0">
        <li class="text-base sm:text-2xl font-bold">
          <NuxtImg
            src="/logo-movimento.png"
            width="180"
            height="38"
            alt="Logo do Movimento Codernista"
            quality="70"
            class="rounded-md"
          />
        </li>
      </ul>
    </div>
  </div>
</template>
